import React from "react";
import VideoItem from "./VideoItem";

const VideoList = ({ videos = [], onVideoSelect }) => {
  // Add this debug line temporarily
  console.log("VideoList received videos:", videos);

  if (!Array.isArray(videos)) return <p>No videos found.</p>;

  return (
    <div className="video-list">
      {videos.map((video, index) => (
        <VideoItem
          key={video.id?.videoId || index} // fallback key
          video={video}
          onVideoSelect={onVideoSelect}
        />
      ))}
    </div>
  );
};

export default VideoList;
